//#region 3rd party imports

import { MapFeatureInteractionEvent, ViewStackController } from "gertrud";
import { SimpleGeodataMapModuleConfig } from "atlas-shared";
//#endregion 3rd party imports


//#region Local imports
import { registerMapModule } from "../mapModuleRegistry";
import { AtlasMapModule } from "../AtlasMapModule";
import { MapModuleViewStackItem } from "@/MapModuleViewStackItem";
import { sidebarPanelNames } from "@/sidebarPanelNames";
import { sidebarPanelRoles } from "@/sidebarPanelRoles";
//#endregion Local imports


export class SimpleGeodataMapModule extends AtlasMapModule {

    moduleConfig: SimpleGeodataMapModuleConfig


    selectedFeatureIds: string[] = []


    constructor(config: SimpleGeodataMapModuleConfig,
        vsc: ViewStackController) {

        super(config, vsc)

        this.moduleConfig = config

    }


    initSidebar(): void {
        const compName = this.moduleConfig.sidebarRootComponent || sidebarPanelNames.SIMPLE_GEODATA_MAIN

        const item: MapModuleViewStackItem = {
            componentName: compName,
            props: {
                viewStackController: this.vsc,
                mapModule: this
            },
            role: 'simplegeodata-main',
            id: '',
            title: this.moduleConfig.title
        }

        this.vsc.addItem(item)
    }




    onFeatureClick = (event: MapFeatureInteractionEvent) => {


        if (!event.feature) {
            return
        }


        //#region If the feature is a cluster point, zoom in on the cluster region
        if (event.feature.properties?.cluster) {

            this.map?.fitBounds(event.feature.properties.cluster_bbox, {
                animate: true,
                padding: 100
            })

            return
        }
        //#endregion If the feature is a cluster point, zoom in on the cluster region



        //#region Perform feature selection/deselection
        const featureId = event.feature?.properties.id

        if (this.selectedFeatureIds.includes(featureId)) {
            // Deselect
            if (this.moduleConfig.allowUnselect) {
                this.selectedFeatureIds = this.selectedFeatureIds.filter(id => id != featureId)
            }
        } else {
            if (this.moduleConfig.selectMode == "single") {
                // Single select mode
                this.selectedFeatureIds = [featureId]
            } else if (this.moduleConfig.selectMode == "multi") {
                // Multi select mode
                this.selectedFeatureIds.push(featureId)
            }
        }

        this.setHighlightFilter(this.selectHighlightLayers, this.selectedFeatureIds)
        //#endregion Perform feature selection/deselection



        //#region Add feature info panel to the sidebar

        const item: MapModuleViewStackItem = {

            componentName: this.moduleConfig.featureInfoComponent || sidebarPanelNames.SIMPLE_GEODATA_FEATURE_INFO,
            props: {
                mapModule: this,
                featureId: event.feature?.properties.id
            },
            role: sidebarPanelRoles.FEATURE_INFO,
            id: '',
            title: (event.feature.properties?.name || this.moduleConfig.title + ": Details")
        }

        this.vsc.addItem(item)


        //#endregion Add feature info panel to the sidebar


    }


    onOutsideClick = (e: MapFeatureInteractionEvent) => {
        if (this.moduleConfig.unselectOnOutsideClick) {
            // Clicked on empty space -> clear all selections
            this.selectedFeatureIds = []
            this.setHighlightFilter(this.selectHighlightLayers, this.selectedFeatureIds)
        }
    }


    onFeatureIn = (event: MapFeatureInteractionEvent): boolean => {

        const featureId = event.feature?.properties.id

        if (!featureId) {
            return false
        }

        this.setHighlightFilter(this.hoverHighlightLayers, [featureId])

        if (event.feature?.properties.cluster) {

            const m = this.map

            if (m) {
                m.setTooltip(event.feature.properties.point_count_abbreviated + " gruppierte Objekte. Anklicken um hineinzuzoomen.")
            }

        }

        return true
    }


    onFeatureOut = (event: MapFeatureInteractionEvent): boolean => {
        this.setHighlightFilter(this.hoverHighlightLayers, [])
        return true
    }


    tooltipFunc(feature: GeoJSON.Feature): string | null {
        return feature.properties?.name || null;
    }
}


registerMapModule("SimpleGeodataMapModule", SimpleGeodataMapModule);